import React, { useMemo, useState } from 'react';
import { Card, Modal } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import GetLabel from 'DisplayFramework/components/GetLabel';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataTable/DataTable';
import { AssetFutureValueContextUseResponse } from 'services/assets';

export type assetfvscheduleProps = Pick<ModalProps, 'onCancel' | 'visible'> & {
  controller?: React.ReactElement;
  AssetfvcontextuseResponse: AssetFutureValueContextUseResponse[];
};

const AssetDVuseScheduleModal = ({
  AssetfvcontextuseResponse = [],
  controller,
  onCancel: onCancelProp,
  visible: visibleProp,
  ...otherProps
}: assetfvscheduleProps) => {
  const [visible, setVisible] = useState(false);

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'attcodelabel',
        width: 150,
        fixed: 'left',
      },
      {
        dataIndex: 'usevalue',
        width: 180,
      },
    ],
    []
  );

  return (
    <>
      {controller &&
        React.cloneElement(controller, { onClick: () => setVisible(true) })}

      <Modal
        title={<GetLabel label="AssetFVuseContextSchedule" />}
        footer={null}
        width={600}
        style={{ top: '20px', height: '400px' }}
        visible={controller ? visible : visibleProp}
        onCancel={controller ? () => setVisible(false) : onCancelProp}
        centered
        {...otherProps}
      >
        <Card>
          <DataGrid
            columns={columns}
            dataSource={AssetfvcontextuseResponse}
            pagination={false}
            rowKey="fvuseid"
            size="small"
            hideFilters
            bordered
          />
        </Card>
      </Modal>
    </>
  );
};

export default AssetDVuseScheduleModal;
